module.exports = __webpack_public_path__ + "img/MegaPromo_Teaser_24_03.d4c7c885.jpg";